<template>
  <div class="park-detail-info-ad">
    <div class="park-detail-info-sub-title">●热门推荐</div>
    <div
      v-for="(popularPushData, index) in popularPushDatas"
      :key="index"
      class="park-detail-info-ad-item"
    >
      <img
        :src="
          popularPushData.imgUrl
            ? popularPushData.imgUrl
            : require('../../../assets/images/home/land.png')
        "
        class="ad-img-t"
      />
      <div class="ad-name">{{ popularPushData.name }}</div>
      <div class="ad-price">{{ popularPushData.price }}万元</div>
      <div class="ad-info-box">
        <div>
          <img :src="require('@/assets/images/home/icon2.png')" />
          {{ popularPushData.person }}
        </div>
        <div>
          <img :src="require('@/assets/images/home/icon4.png')" />
          {{ popularPushData.countyName }}
        </div>
        <div>
          <img :src="require('@/assets/images/home/icon5.png')" />
          {{ popularPushData.phone }}
        </div>
        <div>
          <img :src="require('@/assets/images/home/icon3.png')" />
          {{ popularPushData.area }}公顷
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import img1 from "@/assets/images/home/land.png";
import img2 from "@/assets/images/home/notice.png";
import { landList } from "@/api/setting/investment";
/**
 * @Author LuoYang
 * @Email toluoyang@qq.com
 * @Date 2022/7/18 15:29
 * @Description 地块热门推荐
 */
export default {
  name: "LandPopularPush",
  data() {
    return {
      popularPushDatas: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      let search = { size: 2, statistical: 1, current: 1 };
      let { data: res } = await landList(search);
      if (res.success) {
        let list = res.data.records;
        this.total = res.data.total;

        list.forEach((item) => {
          if (item.pronounceImages) {
            let imgUrl =
              item.pronounceImages.length > 0
                ? systemConfig.imgServer +
                  systemConfig.imgApi +
                  item.pronounceImages[0].filePath
                : null;
            this.$set(item, "imgUrl", imgUrl);
          }
        });

        this.popularPushDatas = list;
      }
    },
  },
};
</script>

<style scoped>
.park-detail-info-ad {
  background-color: #f9f9f9;
  height: fit-content;
}

.park-detail-info-sub-title {
  color: #495eb8;
  border-bottom: dashed 1px #e0e0e0;
  padding: 2px;
}

.park-detail-info-ad-item {
  border: solid 1px #cbcbcb;
  padding: 4px;
  margin: 8px 6px;
}

.ad-img-t {
  width: 100%;
  height: 150px;
}

.ad-name {
  color: #5c5c5c;
  padding: 4px 0;
}

.ad-price {
  color: #1446a6;
  font-weight: bold;
  padding: 4px 0;
}

.ad-info-box {
  margin-top: 4px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  font-size: 0.75rem;
  color: #5c5c5c;
}
</style>
